import React from 'react';
import { useEffect, useState } from "react";
import { Row, Col, Card, Form, Button, FormControl } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { useNavigate, useParams, Link } from 'react-router-dom';
import API from "../../services/axiosInstance";
import { FormLoader, useFormLoader } from '../common_modules/loader';
import Select, { components } from "react-select";
import usePreventMultiClick from '../utils/SubmitPrevent';
import { FaS } from 'react-icons/fa6';

const ACCOUNT_TYPE_ID = 2;

const AddUser = () => {
    const [userData, setUserData] = useState("");
    const [roleList, setRoleList] = useState([]);
    const [activePubList, setActivePubList] = useState("");
    const [publisherOption, setPublisherOption] = useState([]);
    const [selectedPublisher, setSelectedPublisher] = useState([]);

    const navigate = useNavigate();
    const { id } = useParams();
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook
    const { btnClicked, setBtnClicked } = usePreventMultiClick();

    const { handleSubmit, register, reset, watch, formState: { errors } } = useForm({
        defaultValues: {
            name: "",
            userId: "",
            password: "",
            confirmPassword: "",
            email: "",
            roleSetId: "",
            reportingType: "0",
            allowedAccounts: "",
            accountType: ACCOUNT_TYPE_ID,
        }
    });

    const password = watch("password");
    const reportingType = watch("reportingType");

    const userRoleList = async () => {
        startLoading();
        try {
            const roleListRes = await API.get(`tech/roles/set/list/limited?id=${ACCOUNT_TYPE_ID}`);
            if (roleListRes.status === 200) {
                setRoleList(roleListRes?.data?.data);
            }
        } catch (error) { } finally {
            stopLoading();
        }
    }

    const onSubmit = async (data) => {
        if (btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            // If editing and password is empty, remove it
            if (id && !data.password) {
                delete data.password;
                delete data.confirmPassword;
            }

            // trim the white scpace of user_id
            data.userId = (data.userId || "").trim();

            const response = id
                ? await API.put(`/tech/users/edit/user/${id}`, data)
                : await API.post('/tech/users/signup', data);

            if (response?.data?.data != null) {
                alert(response?.data?.message);
                navigate("/user");
            } else {
                alert(response?.data?.message);
            }

        } catch (error) { } finally {
            setBtnClicked(false);
            stopLoading();
        }
    }

    const getUserById = async () => {
        startLoading();
        try {
            const response = await API.get(`tech/users/user/${id}`);
            if (response.status === 200) {
                const result = response.data.data;
                setUserData(result);
                reset({
                    ...result,
                    roleSetId: String(result.roleSetId),
                    // confirmPassword: result.password
                    password: "",
                    confirmPassword: ""
                });
            }
        } catch (error) { } finally {
            stopLoading();
        }
    };

    const onChangeHandler = (selected) => {
        setSelectedPublisher(selected);
    }

    const getPublisherList = async () => {
        const URL = `/publisher/listing/limited`;
        const response = await API.get(URL);

        if (response.status == 200) {
            const data = response?.data?.data;
            setActivePubList(data);

            const options = data.map(item => ({
                value: item.id,
                label: item.userId
            }));
            setPublisherOption(options);
        }
    }

    useEffect(() => {
        const loadData = async () => {
            await userRoleList();
            if (id) {
                await getUserById();
            }
        };
        loadData();
    }, []);

    // useEffect(() => {
    //     if (reportingType > 0) {
    //         if (reportingType == 2) {
    //             console.log("reportingType Changed: " + reportingType);
    //             // fire api for get publisher list.
    //             getPublisherList();
    //         }
    //     }
    // }, [reportingType]);

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <span>User</span>
                <Link to={'/user'}><span>User Listing</span></Link>
                {userData ? <span>{userData?.name}</span> : ''}
                <span>{id ? "Update" : "Create"}</span>
                {/* {id ? <span>{id}</span> : ''} */}
            </div>
            <Card className="p-3 instreamRows">
                <h6 className="title">{id ? `Update` : `Create`} User</h6>
                <span className="text-danger mb-5" style={{ fontSize: "12px" }}>
                    All fields marked with * are mandatory
                </span>

                <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                    {/* Dummy fields to stop chrome autofill */}
                    <input type="text" name="fakeuser" style={{ display: "none" }} />
                    <input type="password" name="fakepassword" style={{ display: "none" }} />

                    <Row>
                        <Col md={3}>
                            <label>User Name <span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            <Form.Control
                                type="text"
                                placeholder="Enter here..."
                                autoComplete="off"
                                {...register("name", {
                                    required: "User Name is required",
                                    minLength: {
                                        value: 5,
                                        message: "User Name must be at least 5 characters"
                                    },
                                    maxLength: {
                                        value: 30,
                                        message: "User Name not more then 30 characters"
                                    },
                                    validate: value =>
                                        value.trim() !== "" || "cannot be empty spaces"
                                })}
                            />
                            {errors.name && <p className="text-danger">{errors.name.message}</p>}
                        </Col>
                    </Row>

                    <Row>
                        <Col md={3}>
                            <label>User ID <span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            <Form.Control
                                disabled={id ? true : false}
                                type="text"
                                placeholder="Enter here..."
                                autoComplete="new-password"
                                {...register("userId", {
                                    required: "User ID is required",
                                    minLength: {
                                        value: 5,
                                        message: "User Id must be at least 5 characters"
                                    },
                                    maxLength: {
                                        value: 30,
                                        message: "User Id not more then 30 characters"
                                    },
                                    validate: value =>
                                        value.trim() !== "" || "cannot be empty spaces"
                                })}
                            />
                            {errors.userId && <p className="text-danger">{errors.userId.message}</p>}
                        </Col>
                    </Row>

                    <Row>
                        <Col md={3}>
                            <label>Password <span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            <FormControl
                                type="password"
                                placeholder="Enter here..."
                                autoComplete="new-password"
                                {...register("password",
                                    {
                                        // required: "Password is required",
                                        required: id ? false : "Password is required",
                                        minLength: {
                                            value: 6,
                                            message: "Password must be at least 6 characters"
                                        },
                                        maxLength: {
                                            value: 15,
                                            message: "Password not more then 15 characters"
                                        },
                                        validate: value => {
                                            if (!value && id) return true;
                                            return value.trim() !== "" || "cannot be empty spaces"
                                        }
                                    })}
                            />
                            {errors.password && <p className="text-danger">{errors.password.message}</p>}
                        </Col>
                    </Row>

                    <Row>
                        <Col md={3}>
                            <label>Confirm Password <span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            <FormControl
                                type="password"
                                placeholder="Enter here..."
                                autoComplete="new-password"
                                {...register("confirmPassword", {
                                    // required: "Confirm password is required",
                                    required: id ? false : "Password is required",
                                    validate: (value) => {
                                        if (!password && !value && id) return true;
                                        return value === password || "Password do not match";
                                    },
                                })}
                            />
                            {errors.confirmPassword && <p className="text-danger">{errors.confirmPassword.message}</p>}
                        </Col>
                    </Row>

                    <Row>
                        <Col md={3}>
                            <label>Email <span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            <FormControl
                                type="email"
                                placeholder="Enter here..."
                                autoComplete="off"
                                {...register("email", {
                                    required: "Email is required",
                                    validate: value =>
                                        value.trim() !== "" || "cannot be empty spaces"
                                })}
                            />
                            {errors.email && <p className="text-danger">{errors.email.message}</p>}
                        </Col>
                    </Row>

                    <Row>
                        <Col md={3}>
                            <label>Select Role <span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            <select
                                className="form-select"
                                {...register("roleSetId", { required: "Role is required" })}
                            >
                                <option value="">Please Select</option>

                                {roleList?.map((role, index) => (
                                    <option key={index} value={role?.id}>
                                        {role?.roleSetName}
                                    </option>
                                ))}

                            </select>

                            {errors.roleSetId && <p className="text-danger">{errors.roleSetId.message}</p>}
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col md={3}>
                            <label>Reporting Type <span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            <select className="form-select" {...register("reportingType", { required: "Role is required" })}>
                                <option value="0">None</option>
                                <option value="2">Publisher</option>
                            </select>

                            {errors.reportingType && <p className="text-danger">{errors.reportingType.message}</p>}
                        </Col>
                    </Row> */}
                    {/* <div>
                        {
                            reportingType > 0 ?
                                reportingType == 2 ?
                                    <div>
                                        <h5>Select Publishers</h5>
                                        <Row>
                                            <Col md={3}>
                                                <label>Publishers <span className="text-danger">*</span></label>
                                            </Col>
                                            <Col md={5}>
                                                <Select
                                                    name="domain"
                                                    options={publisherOption}
                                                    value={selectedPublisher}
                                                    isSearchable={true}
                                                    onChange={(selected, current) => onChangeHandler(selected)}
                                                    isMulti
                                                    closeMenuOnSelect={false}
                                                    placeholder="None"
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                    : ""
                                : ""
                        }
                    </div> */}

                    <Button
                        type="submit"
                        variant="primary"
                        className="mt-3 submitBtn"
                        size="lg"
                        disabled = {btnClicked}
                    >
                        {id ? `Update` : `Create`}
                    </Button>

                    <Button
                        type="button"
                        variant="secondary"
                        className="mx-5 mt-3 cancelBtn"
                        onClick={() => navigate("/user")}
                    >
                        Cancel
                    </Button>
                </form>

            </Card>
        </FormLoader>
    )
}

export default AddUser;